import { detect, OS_TYPE, APP_TYPE, BROWSER_TYPE, DEVICE_TYPE } from '@iv/shared/src/detect';

const detectInfo = detect();

// app类型
export const { appType, appVersion, osVersion, osType, deviceType, isMobile } = detectInfo;

// 腾讯视频
export const isTenvideo = appType === APP_TYPE.tenvideo;

// Android
export const isAndroid = osType === OS_TYPE.android;

// iPad
export const isIpad = deviceType === DEVICE_TYPE.ipad;

// iPhone
export const isIPhone = deviceType === DEVICE_TYPE.iphone;

// windows
export const isWindows = osType === OS_TYPE.windows;

// mac os
export const isMac = osType === OS_TYPE.macOs;

// 腾讯视频 androidPad 端
export const isTenvideoAndroidPad = isAndroid && isTenvideo;

// Pad UN 模式（un pad版本就是phone的app包）
export const isUn = /uiType=LARGE|HUGE|MAX/.test(location.href);

// 腾讯视频iPad客户端
export const isTenvideoPad = isIpad && isTenvideo && !isUn;

// 腾讯视频phone端(android || iPhone || UN）
export const isTenvideoPhone = (isAndroid || isIPhone || isUn) && isTenvideo;

// 腾讯视频windows PC客户端
export const isTenvideoWindows = isWindows && isTenvideo;

// 腾讯视频Mac客户端
export const isTenvideoMac = isMac && isTenvideo;

// 腾讯视频网页端
export const isTenvideoWeb = !isTenvideoPhone && !isTenvideoWindows && !isTenvideoPad;

// 微博客户端
export const isWeiBo = isMobile && appType === APP_TYPE.weibo;

// 微信
export const isWeixin = isMobile && appType === APP_TYPE.weixin;

// QQ
export const isQQ = isMobile && appType === APP_TYPE.qq;

// 是否X5浏览器
export const isTBS = isAndroid && appType === BROWSER_TYPE.tbs;

// 是否华为手机
export const isHuawei = deviceType === DEVICE_TYPE.huawei;
